import PropTypes from 'prop-types';
import React from 'react';
import humanize from 'underscore.string/humanize';
import { localize, t } from '../i18n';

const Severity = function Severity(props) {
  const {
    className,
    severity,
  } = props;
  const severityCls = ['severity'];
  if (className) {
    severityCls.push(className);
  }
  let severityDisplay = humanize(severity);
  const isCritical = severity === 'critical';
  if (isCritical) {
    severityDisplay = props.t('Urgent');
  }
  return (
    <span className={severityCls.join(' ')}>
      {severityDisplay}
    </span>
  );
};

Severity.propTypes = {
  className: PropTypes.string,
  severity: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
};

Severity.defaultProps = {
  status: t('critical'),
};

export default localize(Severity);



// WEBPACK FOOTER //
// ./src/components/Severity.js